import type { ContactImportRow, ExternalContactRow } from "@/lib/contactsDirectoryClient";

export type DirectoryListingFilter = "all" | "org_staff" | "vendors" | "users" | "non_users";

export type MatchResolution = "keep_old" | "keep_new" | "merge";

export type ImportMatch = {
  key: string;
  existing: ExternalContactRow;
  incoming: ContactImportRow;
  resolution: MatchResolution;
  mergedDraft: ContactImportRow;
  matchReason: string;
};

export type ReportingForestNode = {
  key: string;
  children: ReportingForestNode[];
};

export function affiliationDirectoryBadges(affiliation: string | null | undefined, hierarchy: string | null | undefined) {
  const aff = String(affiliation || "org_affiliated").toLowerCase();
  const hier = String(hierarchy || "full").toLowerCase();
  if (aff === "vendor_partner") {
    return (
      <span className="inline-flex items-center rounded-full border border-rose-300 bg-rose-50 px-2 py-0.5 text-[11px] text-rose-900">
        Vendor / partner
      </span>
    );
  }
  if (aff === "platform_global") {
    return (
      <span className="inline-flex items-center rounded-full border border-slate-300 bg-slate-50 px-2 py-0.5 text-[11px] text-slate-800">
        Platform
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-full border border-emerald-300 bg-emerald-50 px-2 py-0.5 text-[11px] text-emerald-900">
      Directory staff{hier === "none" ? " · not in org chart" : ""}
    </span>
  );
}

export function createEmptyExternalForm() {
  return {
    id: "" as string,
    name: "",
    email: "",
    phone: "",
    company: "",
    title: "",
    department: "",
    contact_path: "",
    visibility_level: "1",
    max_downstream_visibility_level: "",
    location_id: "",
    scope: "org",
    topics: "",
    affiliation: "org_affiliated",
    hierarchy_participation: "full",
    reports_to_external_id: "",
    allow_vendor_hierarchy_override: false,
    allow_vendor_reporting_line: false,
  };
}

export const CONTACT_PATH_OPTIONS = [
  "dealer_paperwork",
  "delivery_scheduling",
  "service_scheduling",
  "crm_access",
  "marketing_materials",
  "steel_vendors",
] as const;

export const TOPIC_OPTIONS = [
  "general_support",
  "general_contact",
  "building_construction",
  "timelines",
  "special_orders",
  "warranty_claims",
  "delivery_reschedule",
  "crm_workflows",
  "facebook_ads",
  "google_ads",
  "dealer_paperwork",
] as const;
